var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as initialMoment from "moment";
/**
 * Hack
 * Getting moment to play nicely with typescript, tests AND react-native is problematic
 * This is the only way i've found so far to get it working. Solution from:
 * https://github.com/palantir/blueprint/issues/959#issuecomment-335965129
 */
// @ts-ignore
var moment = initialMoment.default || initialMoment;
export default function groupWalletItemsByDate(walletItems, results) {
    var existing = __spreadArrays(walletItems);
    results.forEach(function (result) {
        var createdAt = result.createdAt ? result.createdAt : result.transfer.createdAt;
        var resultDate = moment(createdAt).startOf("day");
        var lastExistingDay = existing[existing.length - 1];
        if (lastExistingDay && resultDate.isSame(lastExistingDay.date.startOf("day"))) {
            lastExistingDay.data.push(result);
        }
        else {
            existing.push({
                date: moment(createdAt).startOf("day"),
                data: [result]
            });
        }
    });
    return {
        results: existing
    };
}
